module.exports = __webpack_public_path__ + "img/denmark-female.512bd28a.png";